/**
 * Video list component JS.
 */

import { h, app } from 'hyperapp'
import { AllHtmlEntities as Entities } from 'html-entities';

if ( typeof audioData !== 'undefined' ) {
	( function( audioData, rssData ) {
		if ( ! document.getElementById( 'audio-player-front' ) ) {
			return
		}

		/**
		 * Functions
		 */
		const groupAlphabetically = ( collection ) => {
			return collection.reduce( ( acc, item ) => {
				const firstLetter = item.audio.charAt( 0 ).toLowerCase();

				if ( acc[ firstLetter ] ) {
					acc[ firstLetter ].push( item );
				} else {
					acc[ firstLetter ] = [ item ];
				}

				return acc;
			}, {} );
		}

		const filterAudio = ( collection, filters ) => {
			if ( ! filters || filters.type.value === '' ) {
				return collection;
			}

			if ( filters.type.value && collection.length ) {
				const type = filters.type.value;

				// Find audios that start with the type value.
				collection = collection.filter( item => audioData.relations['audio_type'][ type ].find( type => type === item.ID ) )
			}

			return collection;
		}

		const sortAudio = ( a, b ) => {
			return new Date(b.date) - new Date(a.date);
		}

		const filterRss = ( collection, filters ) => {
			if ( ! filters || filters.type.value === '' ) {
				return collection;
			}

			if ( filters.type.value && collection.length ) {
				const type = filters.type.value;

				// Find audios that start with the type value.
				if ( rssData.relations['audio_type'][ type ] ) {
					collection = collection.filter( item => rssData.relations['audio_type'][ type ].find( type => type === item.ID ) )
				} else {
					return [];
				}
			}

			return collection;
		}

		const filtersEmpty = ( filters ) => {
			for ( var filter in filters ) {
				// If the string is not empty.
				if ( filters[ filter ].value.length > 0 ) {
					return false;
				}
			}

			return true;
		}

		/**
		 * App Components
		 */
		const entities = new Entities();

		const defaultFilters = {
			'type': { value: audioData.types[0].term_id },
		}

		const audios = filterAudio( audioData.audio, defaultFilters );
		const rss = filterRss( rssData.rss, defaultFilters );

		const allAudio = [ ...audios, ...rss ].sort( sortAudio );

		const state = {
			types: audioData.types,
			relations: audioData.relations,
			audio: audioData.audio,
			rss: rssData.rss,
			audioPage: audioData.audio_page,
			currentAudio: allAudio[0],
			autoPlay: false,
			image: audioData.image,
			filters: defaultFilters,
		};

		const actions = {
			updateFilters: ( filter ) => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					state.filters,
					{
						[ filter.key ]: Object.assign(
							{},
							state.filters[ filter.key ],
							{ value: filter.value }
						)
					}
				);

				return nextState;
			},
			setCurrentAudio: ( id ) => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.currentAudio = state.audio.find( item => item.ID === id );

				if ( ! nextState.currentAudio ) {
					nextState.currentAudio = state.rss.find( item => item.ID === id );
				}

				nextState.autoPlay = true;

				return nextState;
			},
			clearFilters: () => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					{
						'search': { value: '' },
						'school': { value: '' },
						'degree': { value: '' },
						'type': { value: '' },
					}
				);

				return nextState;
			}
		};

		const view = ( state, actions ) => {
			return (
				<div class="audio-player-front__container">
					<TypeFilter state={ state } actions={ actions } />
					<AudioPlayer state={ state } actions={ actions } />
				</div>
			)
		}

		const TypeFilter = ( { state, actions } ) => {
			const types = state.types;
			const currentTypeFilter = state.filters.type.value;
			const { updateFilters } = actions;

			const updateTypeFilter = ( event ) => {
				let value = event.target.getAttribute( 'data-id' );
				const filter = 'type';

				// If the value is the same, break execution.
				if ( value === currentTypeFilter ) {
					return;
				}

				updateFilters( { key: filter, value: value } );
			}

			const createButton = ( type ) => {
				const attributes = {
					'class': 'reset type-button',
					'onclick': updateTypeFilter,
					'data-id': type.term_id,
				};

				if ( type.term_id === parseInt( currentTypeFilter ) ) {
					attributes.class += ' active';
					attributes['aria-pressed'] = true;
				}

				return h(
					'button',
					attributes,
					type.name
				);
			}

			return (
				<div class="audio-player-front__type-filter">
					<span class="screen-reader-text">Filter audio results by type.</span>
					{ types.map( createButton ) }
				</div>
			)
		}

		const AudioPlayer = ( { state, actions } ) => {
			return (
				<div class="audio-player-front__player-container">
					<div class="audio-player-front__player">
						{ state.currentAudio && <CurrentAudio key="current-audio" state={ state } actions={ actions } /> }
						{ ! state.currentAudio && <div class="current-audio"><p class="current-audio__label">Insight Meditation</p><h4 class="current-audio__title">Please Select A Talk.</h4></div> }
						<PlayerImage state={ state } actions={ actions } />
						<AudioList state={ state } actions={ actions } />
					</div>
				</div>
			)
		}

		const CurrentAudio = ( { state, actions } ) => {
			return (
				<div class="current-audio"><p class="current-audio__label">{ state.currentAudio.date }</p><h4 class="current-audio__title">{ typeof state.currentAudio.post_title === 'string' ? entities.decode( state.currentAudio.post_title ) : entities.decode( state.currentAudio.post_title[0] ) }</h4></div>
			)
		}

		const PlayerImage = ( { state, actions } ) => {
			const Image = state.image ? <img src={ state.image } class="player-image" width="200" height="200" /> : <div class="player-image"></div>;
			return (
				<div class="player__section">
					<div class="player-image__container">
						{ Image }
						<div class="sonar-wave"></div>
					</div>
					{ state.currentAudio && <AudioControls audio={ state.currentAudio } autoPlay={ state.autoPlay } /> }
				</div>
			)
		}

		const AudioList = ( { state, actions } ) => {
			let { filters } = state;
			const audios = filterAudio( state.audio, filters );
			const rss = filterRss( state.rss, filters );

			const allAudio = [ ...audios, ...rss ].sort( sortAudio );

			return (
				<div class="audio-player-front__list">
					<div class="audio-player-front__audio-list">
						{
							allAudio.map( audio => {
								return (
									<AudioItem key={ audio.id } audio={ audio } state={ state } actions={ actions } />
								);
							} )
						}
					</div>
					<a key="all-audio-link" href={ state.audioPage } class="arrow-link">View All Audio</a>
				</div>

			)
		}

		const AudioItem = ( { audio, state, actions } ) => {
			const updateAudio = ( id ) => ( event ) => {
				// If the value is the same, break execution.
				if ( ( state.currentAudio === id ) || ( state.currentAudio && id === state.currentAudio.ID ) ) {
					return;
				}

				actions.setCurrentAudio( id );
			}

			let className = 'reset audio-player-front__audio';
			className += ( state.currentAudio === audio.ID ) || ( state.currentAudio && audio.ID === state.currentAudio.ID ) ? ' active' : '';

			return (
				<button class={ className } onclick={ updateAudio( audio.ID ) }>
					<p class="italic">{ audio.date }</p>
					<p class="audio-player-front__audio-title">{ typeof audio.post_title === 'string' ? entities.decode( audio.post_title ) : entities.decode( audio.post_title[0] ) }</p>
				</button>
			);
		}

		const AudioControls = ( { audio, autoPlay } ) => {
			const handleAudio = ( element ) => {
				const video = new Plyr( element );
				if ( autoPlay ) {
					video.play()
				}

				return video;
			}

			return (
				<audio oncreate={ handleAudio } class="audio-controls" key={ audio.ID } controls>
					<source src={ audio.url } type="audio/mp3" />
					<p>Your browser doesn't support HTML5 audio. Here is a <a href={ audio.ID }>link to the audio</a> instead.</p>
				</audio>
			)
		}

		const App = app( state, actions, view, document.getElementById( 'audio-player-front' ) )

	} ( audioData, rssData ) );
}



// WEBPACK FOOTER //
// ./assets/js/audio-player-front.js